module.exports = __webpack_public_path__ + "static/main-takeaways-2-ee3c4ca24626f67c623947b749e5887d.png";